export const SliderData = [
    { image: './images/img-1.jpg' },
    { image: './images/img-5.jpg' },
    { image: './images/img-9.jpg' },
    { image: './images/img-11.jpg' },
    { image: './images/imgJano-home.jpg' },
    { image: './images/pifko.jpg' }
];